import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/trainingSite'),
      loading: LoadingComponent
    }),
    path: '/courierView/trainingSite',
    meta: {
      title: '我的培训站点'
    }
  }
]
